import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage: themeMode === 'dark' ? 'url(/images/logos/logo_white.PNG)' : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '20vh',
          }}
        />
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          gutterBottom
          align={'center'}
          color={theme.palette.primary.main}
        >
          Somos Padres: crianza, salud y bienestar para toda la familia
        </Box>
        <Typography
          variant={'h6'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
        >
          El magazine de TNO Network dedicado a que madres y padres reciban información útil, entrevistas con expertos y estrategias reales para criar con confianza. Tu marca acompaña conversaciones que importan en el hogar venezolano.
        </Typography>
        <Typography
          variant={'h5'}
          component={'p'}
          color={theme.palette.primary.main}
          align={'center'}
          sx={{ mt: 3, mb: 2, fontStyle: 'italic' }}
        >
          ¿Qué es Somos Padres?
        </Typography>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://tnonetwork.com/show/somospadres"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            tnonetwork.com/show/somospadres
          </Link>
          {' · '}
          <Link
            href="https://somospadres.info"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            somospadres.info
          </Link>
        </Typography>
        <Typography
          variant={'body1'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
          sx={{ mt: 1 }}
        >
          Programa en formato de entrevista dirigido a familias de Venezuela: salud infantil, educación, pantallas y redes, crianza positiva, maternidad y paternidad con sentido. Creado por <strong>Yelitza Yánez</strong>, editora de SomosPadres.info y voz con 28 años de experiencia en periodismo y branded content. Transmisión en vivo los <strong>martes a la 1:00 PM</strong> (horario Venezuela) por TNO Network.
        </Typography>
      </Box>

      <Box marginTop={6} marginBottom={4}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={3}>
            <Box display="flex" justifyContent="center">
              <Box
                component="img"
                src="/images/Yelitza Yeye Yanez-SomosPadresInfo.png"
                alt="Yelitza Yánez - Ancla de Somos Padres"
                sx={{
                  width: { xs: 200, sm: 250, md: 300 },
                  height: { xs: 200, sm: 250, md: 300 },
                  borderRadius: 2,
                  objectFit: 'cover',
                  boxShadow: 3,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={9}>
            <Typography
              variant={'h5'}
              fontWeight={700}
              gutterBottom
              color={theme.palette.primary.main}
            >
              NUESTRA ANCLA: YELITZA YÁNEZ (YEYÉ)
            </Typography>
            <Typography
              variant={'body2'}
              color={'textSecondary'}
              sx={{ fontStyle: 'italic', mb: 2 }}
            >
              Periodismo que conecta con quienes crían, educan y deciden en familia
            </Typography>
            <Typography variant={'body1'} color={'textSecondary'}>
              <strong>Yelitza Yánez</strong> lidera <strong>Somos Padres</strong> y la revista digital SomosPadres.info. Egresada de la UCV y especialista en Inbound Marketing & Branded Content, combina rigor editorial con cercanía para abordar salud, educación, negocios familiares y bienestar. Profesora en la UCAB y voz del ecosistema TNO Network, ofrece a las marcas un entorno de alta confianza con padres y madres comprometidos.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Who;
